/**
 * Environment configuration
 * Loads and validates environment variables
 */

interface EnvConfig {
  supabase: {
    url: string;
    anonKey: string;
  };
  api: {
    baseUrl: string;
  };
  aws: {
    s3Bucket: string;
    region: string;
  };
  openai: {
    apiKey: string;
  };
}

function getEnvVar(key: string, defaultValue?: string): string {
  const value = import.meta.env[key] || defaultValue;
  
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  
  return value;
}

export const env: EnvConfig = {
  supabase: {
    url: getEnvVar('VITE_SUPABASE_URL'),
    anonKey: getEnvVar('VITE_SUPABASE_ANON_KEY'),
  },
  api: {
    baseUrl: getEnvVar('VITE_API_BASE_URL', 'http://localhost:3001/api/v1'),
  },
  aws: {
    s3Bucket: getEnvVar('VITE_AWS_S3_BUCKET'),
    region: getEnvVar('VITE_AWS_REGION', 'us-east-1'),
  },
  openai: {
    apiKey: getEnvVar('VITE_OPENAI_API_KEY'),
  },
};

export const isDevelopment = import.meta.env.DEV;
export const isProduction = import.meta.env.PROD;
